import { CategoryFilterOption, SubcategoryOptionsMap } from '@immosky/types';
import { createAction, props } from '@ngrx/store';

export enum CategoryActions {
  Reset = '[Filter] Reset Category Filter',
  SetMainCategory = '[Filter] Set Category Filter',
  SetMainCategoryBasedOnValue = '[Filter] Set Category Filter Based On Value',
  SetSubcategory = '[Filter] Set Subcategory Filter',
  SetSubcategoriesBasedOnValues = '[Filter] Set Subcategory Filters By Value',
}

export const resetCategoryFilter = createAction(CategoryActions.Reset);

export const setMainCategoryFilter = createAction(
  CategoryActions.SetMainCategory,
  props<{ filter: CategoryFilterOption }>()
);

export const setMainCategoryFilerBasedOnUrlValue = createAction(
  CategoryActions.SetMainCategoryBasedOnValue,
  props<{ value: string }>()
);

export const setSubcategoryFilter = createAction(
  CategoryActions.SetSubcategory,
  props<{ filter: SubcategoryOptionsMap }>()
);

export const activateSubcategoryFiltersByValue = createAction(
  CategoryActions.SetSubcategoriesBasedOnValues,
  props<{ values: string[] }>()
);
